import _ from "lodash";

export function unionSelects(args) {
    var union = _.union.apply(_, args.selects);

    var groupedSelects = _(union)
        .groupBy(function (s) { return s.substr(0, s.lastIndexOf("/")); })
        .mapValues(function (list: any[]) {
            return _.map(list, function (s) { return s.slice(s.lastIndexOf("/") + 1); });
        })
        .mapValues(function (list: any[]) {
            return _.includes(list, "*") ? ["*"] : list;
        })
        .value();

    groupedSelects[""] = groupedSelects[""] || ["Id"];
    _.forEach(args.expand, function (expand) {
        groupedSelects[expand] = groupedSelects[expand] || ["Id"];
    });

    var selects = _(groupedSelects)
        .keys()
        .flatMap(function (path) { return _.map(groupedSelects[path], function (s) { return path == "" ? s : path + "/" + s; }); })
        .value();

    return selects;
}
